import { render } from "./FirebaseUI.vue?vue&type=template&id=0d8ce48b"
import script from "./FirebaseUI.vue?vue&type=script&lang=js"
export * from "./FirebaseUI.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__